import {useCallback, useState} from 'react';

export function useForceUpdate() {
    const [, setState] = useState(0);

    return useCallback(() => setState(state => state + 1), [setState]);
}

export function useForceUpdateWithState() {
    const [state, setState] = useState(0);

    return {
        forceUpdateCallback: useCallback(() => setState(state => state + 1), [setState]),
        state: state,
    };
}

